module.exports = __webpack_public_path__ + "static/media/fortnite-death.9338f710.mp3";